export default __webpack_public_path__ + "static/media/fiat-logo.528855c2.png";